import React from 'react';
import { X, AlertTriangle } from 'lucide-react';
import { DialogBackdrop } from '../../../components/ui/dialog-backdrop';
import styles from './EditAutomationTemplate.module.css';

const { reorderWarningDialog } = styles;

interface ReorderWarningDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const ReorderWarningDialog: React.FC<ReorderWarningDialogProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  if (!open) return null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <>
      <DialogBackdrop onClose={onClose} />
      <dialog className={reorderWarningDialog} open>
        <header>
          <h2>Save Changes?</h2>
          <button onClick={onClose} type="button" aria-label="Close">
            <X />
          </button>
        </header>
        <main>
          <p>
            You have added, removed, or reordered automation steps. These structural changes may affect
            users who are currently progressing through this automation.
          </p>
          <p>Are you sure you want to save?</p>
        </main>
        <footer>
          <button type="button" onClick={onClose}>
            Cancel
          </button>
          <button type="button" onClick={handleConfirm} data-variant="warning">
            <AlertTriangle />
            Save Changes
          </button>
        </footer>
      </dialog>
    </>
  );
};
